import { useQuery } from '@tanstack/react-query';
import { fetchLivePaymentLink } from '../services/paymentLinks';
import { agreementKeys } from './agreementKeys';

export const PAYMENT_LINK_POLL_MS = 15_000;

/** With `poll`, refetches every 15 s while a link is live and the tab is visible, and on focus. */
export function useLivePaymentLinkQuery(id: string | undefined, enabled: boolean, poll = false) {
    return useQuery({
        queryKey: agreementKeys.livePaymentLink(id ?? ''),
        queryFn: () => fetchLivePaymentLink(id!),
        enabled: !!id && enabled,
        staleTime: 0,
        refetchInterval: poll ? (query) => (query.state.data ? PAYMENT_LINK_POLL_MS : false) : false,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: poll,
    });
}
